import { inject, Injectable } from '@angular/core'
import { LoadingController } from '@ionic/angular/standalone'

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  loadingCtrl = inject(LoadingController)

  private loading: HTMLIonLoadingElement | undefined
  private requestCount = 0

  async showLoading(timeout: number) {
    this.requestCount++

    if (this.requestCount === 1 && !this.loading) {
      this.loading = await this.loadingCtrl.create({
        duration: timeout,
      })
      await this.loading.present()
    }
  }

  async hideLoading() {
    this.requestCount--
    if (this.requestCount === 0 && this.loading) {
      await this.loading.dismiss()

      const top = await this.loadingCtrl.getTop()
      if (top) {
        await top.dismiss()
      }

      this.loading = undefined
    }
  }

  async resetLoader() {
    this.requestCount = 0
    if (this.loading) {
      await this.loading.dismiss()
      this.loading = undefined
    }
  }
}
